'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _isString2 = require('lodash/isString');

var _isString3 = _interopRequireDefault(_isString2);

exports.default = FieldHint;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _style = require('../../utils/style');

var _text = require('../text');

var _text2 = _interopRequireDefault(_text);

var _icon = require('../icon');

var _icon2 = _interopRequireDefault(_icon);

var _layout = require('../layout');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function FieldHint(props) {
  var hint = props.hint,
      icon = props.icon,
      otherProps = (0, _objectWithoutProperties3.default)(props, ['hint', 'icon']);


  return _react2.default.createElement(
    _layout.Inline,
    (0, _style.pickStyles)(otherProps),
    _react2.default.createElement(
      _text2.default,
      { size: 'extra-small', color: 'navy600', multiline: true },
      icon ? _react2.default.createElement(
        _layout.Inline,
        null,
        (0, _isString3.default)(icon) ? _react2.default.createElement(
          _icon2.default,
          {
            size: 12,
            top: 2,
            marginRight: 5,
            position: 'relative',
            verticalAlign: 'baseline'
          },
          String(icon)
        ) : icon
      ) : null,
      hint
    )
  );
}


//////////////////
// WEBPACK FOOTER
// ./~/@kalo/ui/lib/components/field-hint/field-hint.js
// module id = 313
// module chunks = 114276838955818